import React, { useState, useEffect, useReducer, useCallback, useContext } from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Tooltip from "@material-ui/core/Tooltip";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
// import MessageModal from "../../components/MessageModal"
import ScheduleModal from "../../components/ScheduleModal";
import AppointmentModal from "../../components/AppointmentModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import toastError from "../../errors/toastError";
import moment from "moment";
// import { SocketContext } from "../../context/Socket/SocketContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import usePlans from "../../hooks/usePlans";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "moment/locale/pt-br";
import "react-big-calendar/lib/css/react-big-calendar.css";
import SearchIcon from "@material-ui/icons/Search";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";

import "./Schedules.css"; // Importe o arquivo CSS

// Defina a função getUrlParam antes de usá-la
function getUrlParam(paramName) {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(paramName);
}

const eventTitleStyle = {
  fontSize: "14px", // Defina um tamanho de fonte menor
  overflow: "hidden", // Oculte qualquer conteúdo excedente
  whiteSpace: "nowrap", // Evite a quebra de linha do texto
  textOverflow: "ellipsis", // Exiba "..." se o texto for muito longo
};

const tooltipLineStyle = { fontSize: 13, lineHeight: 1.5 };
const tooltipBodyStyle = { ...tooltipLineStyle, marginTop: 4, maxWidth: 260, whiteSpace: "pre-wrap" };

// Backlog 2026-09-16 ("mostrar detalhes do compromisso/agendamento so'
// passando o mouse, sem precisar clicar"): antes so' dava pra ver os
// detalhes abrindo o modal de edicao. O evento no calendario ja e' um
// <div> customizado (nao o formato padrao do react-big-calendar), entao
// da' pra envolver com o Tooltip do Material-UI normalmente.
const buildScheduleTooltip = (schedule) => (
  <div>
    <div style={{ ...tooltipLineStyle, fontWeight: 700 }}>{schedule?.contact?.name || "Sem contato"}</div>
    <div style={tooltipLineStyle}>{moment(schedule.sendAt).format("DD/MM/YYYY HH:mm")}</div>
    {schedule?.user?.name && <div style={tooltipLineStyle}>Responsável: {schedule.user.name}</div>}
    {schedule?.body && <div style={tooltipBodyStyle}>{schedule.body}</div>}
  </div>
);

const buildAppointmentTooltip = (appointment) => (
  <div>
    <div style={{ ...tooltipLineStyle, fontWeight: 700 }}>{appointment.title}</div>
    <div style={tooltipLineStyle}>
      {moment(appointment.startAt).format("DD/MM/YYYY HH:mm")} – {moment(appointment.endAt).format("HH:mm")}
    </div>
    {appointment?.queue?.name && <div style={tooltipLineStyle}>Setor: {appointment.queue.name}</div>}
    {appointment?.contact?.name && <div style={tooltipLineStyle}>Cliente: {appointment.contact.name}</div>}
    {appointment?.user?.name && <div style={tooltipLineStyle}>Responsável: {appointment.user.name}</div>}
    {appointment?.location && <div style={tooltipLineStyle}>Local: {appointment.location}</div>}
    {appointment?.description && <div style={tooltipBodyStyle}>{appointment.description}</div>}
  </div>
);

const localizer = momentLocalizer(moment);
var defaultMessages = {
  date: "Data",
  time: "Hora",
  event: "Evento",
  allDay: "Dia Todo",
  week: "Semana",
  work_week: "Agendamentos",
  day: "Dia",
  month: "Mês",
  previous: "Anterior",
  next: "Próximo",
  yesterday: "Ontem",
  tomorrow: "Amanhã",
  today: "Hoje",
  agenda: "Agenda",
  noEventsInRange: "Não há agendamentos no período.",
  showMore: function showMore(total) {
    return "+" + total + " mais";
  }
};

const reducer = (state, action) => {
  if (action.type === "LOAD_SCHEDULES") {
    const schedules = action.payload;
    const newSchedules = [];

    schedules.forEach((schedule) => {
      const scheduleIndex = state.findIndex((s) => s.id === schedule.id);
      if (scheduleIndex !== -1) {
        state[scheduleIndex] = schedule;
      } else {
        newSchedules.push(schedule);
      }
    });

    return [...state, ...newSchedules];
  }

  if (action.type === "UPDATE_SCHEDULES") {
    const schedule = action.payload;
    const scheduleIndex = state.findIndex((s) => s.id === schedule.id);

    if (scheduleIndex !== -1) {
      state[scheduleIndex] = schedule;
      return [...state];
    } else {
      return [schedule, ...state];
    }
  }

  if (action.type === "DELETE_SCHEDULE") {
    const scheduleId = action.payload;

    const scheduleIndex = state.findIndex((s) => s.id === scheduleId);
    if (scheduleIndex !== -1) {
      state.splice(scheduleIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "scroll", overflowX: "hidden",
    ...theme.scrollbarStyles,
  },
  calendarToolbar: {
    '& .rbc-toolbar-label': {
      color: theme.mode === "light" ? theme.palette.light : "white",
    },
    '& .rbc-btn-group button': {
      color: theme.mode === "light" ? theme.palette.light : "white",
      border: `1px solid ${theme.mode === "light" ? "#E7E4F2" : "#2E294A"}`,
      borderRadius: 10,
      textTransform: "none",
      padding: "6px 14px",
      '&:hover': {
        color: theme.palette.mode === 'dark' ? '#fff' : '#000',
        backgroundColor: theme.mode === "light" ? "rgba(91,69,224,0.06)" : "rgba(142,124,245,0.10)",
      },
      '&:active': {
        color: theme.palette.mode === 'dark' ? '#fff' : '#000',
      },
      '&:focus': {
        color: theme.palette.mode === 'dark' ? '#fff' : '#000',
      },
      '&.rbc-active': {
        color: "#fff",
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
    },
    '& .rbc-btn-group button + button': {
      marginLeft: 4,
    },
    '& .rbc-event': {
      backgroundColor: theme.palette.primary.main,
      borderRadius: 6,
      border: "none",
    },
    '& .rbc-event.rbc-selected': {
      backgroundColor: theme.palette.primary.main,
      filter: "brightness(0.9)",
    },
    '& .rbc-today': {
      backgroundColor: theme.mode === "light" ? "rgba(91,69,224,0.06)" : "rgba(142,124,245,0.10)",
    },
  },
}));

const Schedules = () => {
  const classes = useStyles();
  const history = useHistory();

  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);


  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [deletingSchedule, setDeletingSchedule] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [schedules, dispatch] = useReducer(reducer, []);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [contactId, setContactId] = useState(+getUrlParam("contactId"));
  const [appointments, setAppointments] = useState([]);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [appointmentModalOpen, setAppointmentModalOpen] = useState(false);

  const { getPlanCompany } = usePlans();

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);
      if (!planConfigs.plan.useSchedules) {
        toast.error("Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.");
        setTimeout(() => {
          history.push(`/`)
        }, 1000);
      }
    }
    fetchData();
  }, [user, history, getPlanCompany]);

  const fetchSchedules = useCallback(async () => {
    try {
      const { data } = await api.get("/schedules", {
        params: { searchParam, pageNumber },
      });

      dispatch({ type: "LOAD_SCHEDULES", payload: data.schedules });
      setHasMore(data.hasMore);
      setLoading(false);
    } catch (err) {
      toastError(err);
    }
  }, [searchParam, pageNumber]);

  const fetchAppointments = useCallback(async () => {
    try {
      const startDate = moment().subtract(6, "months").toISOString();
      const endDate = moment().add(6, "months").toISOString();
      const { data } = await api.get("/appointments", {
        params: { startDate, endDate },
      });
      setAppointments(data);
    } catch (err) {
      toastError(err);
    }
  }, []);

  const handleOpenScheduleModalFromContactId = useCallback(() => {
    if (contactId) {
      handleOpenScheduleModal();
    }
  }, [contactId]);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      fetchSchedules();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [
    searchParam,
    pageNumber,
    contactId,
    fetchSchedules,
    handleOpenScheduleModalFromContactId,
  ]);

  useEffect(() => {
    fetchAppointments();
  }, [fetchAppointments]);

  useEffect(() => {
    // handleOpenScheduleModalFromContactId();
    // const socket = socketManager.GetSocket(user.companyId, user.id);


    const onCompanySchedule = (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({ type: "UPDATE_SCHEDULES", payload: data.schedule });
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_SCHEDULE", payload: +data.scheduleId });
      }
    }

    socket.on(`company${user.companyId}-schedule`, onCompanySchedule)

    return () => {
      socket.off(`company${user.companyId}-schedule`, onCompanySchedule)
    };
  }, [socket, user.companyId]);

  const cleanContact = () => {
    setContactId("");
  };

  const handleOpenScheduleModal = () => {
    setSelectedSchedule(null);
    setScheduleModalOpen(true);
  };

  const handleCloseScheduleModal = () => {
    setSelectedSchedule(null);
    setScheduleModalOpen(false);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleEditSchedule = (schedule) => {
    setSelectedSchedule(schedule);
    setScheduleModalOpen(true);
  };

  const handleCloseAppointmentModal = () => {
    setSelectedAppointment(null);
    setAppointmentModalOpen(false);
  };

  const handleOpenNewAppointmentModal = () => {
    setSelectedAppointment(null);
    setAppointmentModalOpen(true);
  };

  const handleEditAppointment = (appointment) => {
    // Eventos puramente do Google Calendar (nunca criados por aqui) nao
    // tinham linha local em Appointments pra editar - o modal "adota"
    // esse evento na primeira edicao (POST /appointments/adopt-google-
    // event, ver AppointmentModal), criando a linha local vinculada e
    // propagando a mudanca de volta pro Google. Fix 2026-09-16, pedido
    // do usuario ("fiz um pela agenda do google e nao consigo editar por
    // aqui").
    setSelectedAppointment(appointment);
    setAppointmentModalOpen(true);
  };

  const handleDeleteAppointment = async (appointment) => {
    try {
      // Fix 2026-09-28, pedido do usuario ("preciso conseguir excluir um
      // evento do google pela nossa agenda"): antes so' mostrava um toast
      // mandando excluir direto no Google. Evento "google-*" nao tem
      // linha local (nunca foi adotado) - exclui direto na origem via
      // DELETE /appointments/google-event/:eventId em vez de "adotar" so'
      // pra poder apagar em seguida.
      if (String(appointment.id).startsWith("google-")) {
        await api.delete(`/appointments/google-event/${appointment.googleEventId}`, {
          params: { calendarId: appointment.googleCalendarId },
        });
      } else {
        await api.delete(`/appointments/${appointment.id}`);
      }
      toast.success("Compromisso excluido com sucesso!");
    } catch (err) {
      toastError(err);
    }
    await fetchAppointments();
  };

  const handleDeleteSchedule = async (scheduleId) => {
    try {
      await api.delete(`/schedules/${scheduleId}`);
      toast.success(i18n.t("schedules.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingSchedule(null);
    setSearchParam("");
    setPageNumber(1);

    dispatch({ type: "RESET" });
    setPageNumber(1);
    await fetchSchedules();
  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  
  return (
    <MainContainer>
      <ConfirmationModal
        title={
          deletingSchedule &&
          `${i18n.t("schedules.confirmationModal.deleteTitle")}`
        }
        open={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={() => handleDeleteSchedule(deletingSchedule.id)}
      >
        {i18n.t("schedules.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      {scheduleModalOpen && (
        <ScheduleModal
          open={scheduleModalOpen}
          onClose={handleCloseScheduleModal}
          reload={fetchSchedules}
          // aria-labelledby="form-dialog-title"
          scheduleId={
            selectedSchedule ? selectedSchedule.id : null
          }
          contactId={contactId}
          cleanContact={cleanContact}
        />
      )}
      {appointmentModalOpen && (
        <AppointmentModal
          open={appointmentModalOpen}
          onClose={handleCloseAppointmentModal}
          appointment={selectedAppointment}
          reload={fetchAppointments}
        />
      )}
      <MainHeader>
        <Title>{i18n.t("schedules.title")} ({schedules.length})</Title>
        <MainHeaderButtonsWrapper>
          <TextField
            placeholder={i18n.t("contacts.searchPlaceholder")}
            type="search"
            value={searchParam}
            onChange={handleSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ color: "gray" }} />
                </InputAdornment>
              ),
            }}
          />
          <Button
            variant="outlined"
            color="primary"
            onClick={handleOpenNewAppointmentModal}
          >
            Novo Compromisso
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpenScheduleModal}
          >
            {i18n.t("schedules.buttons.add")}
          </Button>
        </MainHeaderButtonsWrapper>
      </MainHeader>
      <Paper className={classes.mainPaper} variant="outlined" onScroll={handleScroll}>
        <Calendar
          messages={defaultMessages}
          formats={{
            agendaDateFormat: "DD/MM ddd",
            weekdayFormat: "dddd"
          }}
          localizer={localizer}
          events={[
            ...schedules.map((schedule) => ({
              title: (
                // O card inteiro abre a edicao (nao so' o lapis) - em varias
                // visualizacoes do calendario (mes, semana com titulo longo)
                // o layout flex espremia os icones pra fora da area visivel/
                // clicavel, entao "clicar pra abrir" parecia nao fazer nada
                // (bug real reportado 2026-08-27). O lapis continua ali como
                // reforco visual, mas o clique funciona em qualquer ponto.
                //
                // Tooltip ao passar o mouse (backlog 2026-09-16): mostra
                // contato/horario/mensagem sem precisar clicar.
                <Tooltip key={`schedule-${schedule.id}`} title={buildScheduleTooltip(schedule)} arrow enterDelay={300}>
                  <div
                    className="event-container"
                    onClick={() => {
                      handleEditSchedule(schedule);
                      setScheduleModalOpen(true);
                    }}
                  >
                    <div style={eventTitleStyle}>{schedule?.contact?.name}</div>
                    <DeleteOutlineIcon
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteSchedule(schedule.id);
                      }}
                      className="delete-icon"
                    />
                    <EditIcon className="edit-icon" />
                  </div>
                </Tooltip>
              ),
              start: new Date(schedule.sendAt),
              end: new Date(schedule.sendAt),
            })),
            ...appointments.map((appointment) => ({
              title: (
                <Tooltip key={`appointment-${appointment.id}`} title={buildAppointmentTooltip(appointment)} arrow enterDelay={300}>
                  <div
                    className="event-container"
                    style={{ borderLeft: `4px solid ${appointment.queue?.color || "#3b82f6"}`, paddingLeft: 4 }}
                    onClick={() => handleEditAppointment(appointment)}
                  >
                    <div style={eventTitleStyle}>📅 {appointment.title}</div>
                    <DeleteOutlineIcon
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteAppointment(appointment);
                      }}
                      className="delete-icon"
                    />
                    <EditIcon className="edit-icon" />
                  </div>
                </Tooltip>
              ),
              start: new Date(appointment.startAt),
              end: new Date(appointment.endAt),
            })),
          ]}
          startAccessor="start"
          endAccessor="end"
          // O react-big-calendar por padrao usa o proprio "title" do evento
          // como tooltip NATIVO do navegador (atributo title="" no <div>) -
          // desde que event.title virou um elemento React (o nosso Tooltip
          // do MUI, adicionado pra mostrar detalhes ao passar o mouse), esse
          // atributo nativo recebia o objeto React inteiro e o navegador
          // convertia pra texto sozinho, aparecendo "[object Object]" (bug
          // reportado 2026-09-28). tooltipAccessor={null} desliga esse
          // tooltip nativo redundante - o nosso Tooltip customizado ja cobre
          // o mesmo hover.
          tooltipAccessor={null}
          style={{ height: 500 }}
          className={classes.calendarToolbar}
        />
      </Paper>
    </MainContainer>
  );
};

export default Schedules;